// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

import LdapUserModal from './ldap_user_modal'

export default class SelectUserModal extends LdapUserModal {
  constructor() {
    super({ only_ldap: false, createLdapUsers: true, closeAfterResolve: false })
  }
}
